"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MintProxyWrapper = void 0;
const spl_token_1 = require("@solana/spl-token");
const web3_js_1 = require("@solana/web3.js");
class MintProxyWrapper {
    constructor(saber) {
        this.saber = saber;
        this.program = saber.programs.MintProxy;
    }
    getProxyMintAuthority() {
        return __awaiter(this, void 0, void 0, function* () {
            const stateAccount = yield this.program.state.address();
            return yield web3_js_1.PublicKey.findProgramAddress([
                Buffer.from([
                    83, 97, 98, 101, 114, 77, 105, 110, 116, 80, 114, 111, 120, 121,
                ]),
                stateAccount.toBytes(),
            ], this.program.programId);
        });
    }
    new({ hardcap, mintAuthority, tokenMint, tokenProgram = spl_token_1.TOKEN_PROGRAM_ID, owner = this.program.provider.wallet.publicKey, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const [proxyMintAuthority, nonce] = yield this.getProxyMintAuthority();
            const instructions = [];
            instructions.push(this.program.state.instruction.new(nonce, hardcap, {
                accounts: {
                    mintAuthority,
                    proxyMintAuthority,
                    owner,
                    tokenMint,
                    tokenProgram,
                },
            }));
            return {
                proxyAuthority: proxyMintAuthority,
                tx: this.saber.newTx(instructions),
            };
        });
    }
    /**
     * Initializes the mint proxy with the given hardcap.
     *
     * The provider must be the mint authority and the owner of the mint.
     *
     * @returns
     */
    initMintProxy({ hardCap, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const owner = this.program.provider.wallet.publicKey;
            const [proxyMintAuthority, nonce] = yield this.getProxyMintAuthority();
            const instructions = [
                this.program.state.instruction.new(nonce, hardCap.toU64(), {
                    accounts: {
                        mintAuthority: owner,
                        proxyMintAuthority,
                        owner,
                        tokenMint: hardCap.token.mintAccount,
                        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                    },
                }),
            ];
            return this.saber.newTx(instructions);
        });
    }
    getMinterInfoAddress(minter) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.program.account.minterInfo.associatedAddress(minter);
        });
    }
    /**
     * Fetches info on a minter.
     * @param minter
     * @returns
     */
    fetchMinterInfo(minter) {
        return __awaiter(this, void 0, void 0, function* () {
            const minterInfoAddress = yield this.getMinterInfoAddress(minter);
            const accountInfo = yield this.program.provider.connection.getAccountInfo(minterInfoAddress);
            if (!accountInfo) {
                return null;
            }
            return this.program.coder.accounts.decode("MinterInfo", accountInfo.data);
        });
    }
    minterAdd(minter, allowance) {
        return __awaiter(this, void 0, void 0, function* () {
            const minterInfo = yield this.program.account.minterInfo.associatedAddress(minter);
            const ix = this.program.state.instruction.minterAdd(allowance, {
                accounts: {
                    auth: { owner: this.program.provider.wallet.publicKey },
                    minter,
                    minterInfo,
                    payer: this.program.provider.wallet.publicKey,
                    rent: web3_js_1.SYSVAR_RENT_PUBKEY,
                    systemProgram: web3_js_1.SystemProgram.programId,
                },
            });
            return this.saber.newTx([ix]);
        });
    }
    /**
     * Updates a minter's allowance.
     * @param minter
     * @param allowance
     * @returns
     */
    minterUpdate(minter, allowance) {
        return __awaiter(this, void 0, void 0, function* () {
            const minterInfo = yield this.program.account.minterInfo.associatedAddress(minter);
            const ix = this.program.state.instruction.minterUpdate(allowance, {
                accounts: {
                    auth: { owner: this.program.provider.wallet.publicKey },
                    minterInfo,
                },
            });
            return this.saber.newTx([ix]);
        });
    }
    minterRemove(minter, superAuthority = this.program.provider.wallet.publicKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const minterInfo = yield this.program.account.minterInfo.associatedAddress(minter);
            const ix = this.program.state.instruction.minterRemove({
                accounts: {
                    auth: { owner: superAuthority },
                    minter,
                    minterInfo,
                    payer: this.program.provider.wallet.publicKey,
                },
            });
            return this.saber.newTx([ix]);
        });
    }
    transferOwnership(nextOwner) {
        return this.saber.newTx([
            this.program.state.instruction.transferOwnership(nextOwner, {
                accounts: { owner: this.program.provider.wallet.publicKey },
            }),
        ]);
    }
    acceptOwnership() {
        return this.saber.newTx([
            this.program.state.instruction.acceptOwnership({
                accounts: { owner: this.program.provider.wallet.publicKey },
            }),
        ]);
    }
    mintProxyExists() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.program.state.fetch();
            }
            catch (e) {
                return false;
            }
            return true;
        });
    }
}
exports.MintProxyWrapper = MintProxyWrapper;
//# sourceMappingURL=index.js.map